// import nodemailer from "nodemailer";
import { generateEmailTemplate } from "./generateEmailTemplate";

const zapierWebhooks = {
  machine: "https://hooks.zapier.com/hooks/catch/17250683/2kb7zc4/",
  print: "https://hooks.zapier.com/hooks/catch/17250683/2kb7zc4/",
  referral: "https://hooks.zapier.com/hooks/catch/17250683/2kb7zc4/",
};

/**
 * Submits form data to either Zapier or Email
 * @param {string} formType - The type of form (general, machine, print, referral)
 * @param {Object} formData - The collected form data
 * @returns {Promise} API response
 */
export const submitForm = async (formType, formData) => {
  if (formType === "general") {
    return sendEmail(formData);
  }

  const webhookURL = zapierWebhooks[formType];

  if (!webhookURL) {
    console.error("❌ No webhook URL found for form type:", formType);
    return { success: false, message: "Invalid form type." };
  }

  try {
    console.group(`📤 Submitting ${formType} form to Zapier`);
    console.log("Form Data Payload:", formData);
    console.groupEnd();

    // Convert to FormData for CORS compatibility
    const formPayload = new FormData();
    Object.keys(formData).forEach((key) => {
      formPayload.append(key, formData[key]);
    });

    const response = await fetch(webhookURL, {
      method: "POST",
      body: formPayload,
    });

    const responseData = await response.text();

    if (response.ok) {
      console.log(`✅ Zapier responded for ${formType} form:`, responseData);
      return { success: true, message: "Form submitted successfully!" };
    } else {
      console.error(`❌ Zapier error for ${formType} form:`, responseData);
      return { success: false, message: "Failed to submit the form." };
    }
  } catch (error) {
    console.error(`🔥 Exception submitting ${formType} form:`, error);
    return { success: false, message: "An error occurred. Please try again." };
  }
};

/**
 * Sends an email using Google Workspace SMTP.
 * @param {Object} formData - The form data
 * @returns {Promise} API response
 */
const sendEmail = async (formData) => {
  try {
    // const transporter = nodemailer.createTransport({
    //   host: "smtp-relay.gmail.com", // Use "smtp.gmail.com" if relay doesn't work
    //   port: 587, // TLS (for SSL, use 465)
    //   secure: false, // Set to true if using port 465 (SSL)
    //   auth: {
    //     user: "info@surfacepix.com", // Your Google Workspace email
    //     pass: "YOUR_APP_PASSWORD", // Replace with the generated App Password
    //   },
    // });

    // const mailOptions = {
    //   from: '"SurfacePix Contact" <info@surfacepix.com>',
    //   to: "info@surfacepix.com", // Send to support email
    //   subject: `New Contact Inquiry from ${formData.firstName} ${formData.lastName}`,
    //   html: generateEmailTemplate(formData),
    // };

    // const info = await transporter.sendMail(mailOptions);
    // console.log("Email sent:", info.response);

    return { success: true, message: "Email sent successfully!" };
  } catch (error) {
    console.error("Error sending email:", error);
    return { success: false, message: "An error occurred. Please try again." };
  }
};

export { sendEmail };
